import { Autocomplete, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { billingAddressSchema } from "../../utils/validationSchemas";
import { toast } from "react-toastify";
import LoadingButton from "@mui/lab/LoadingButton";
import { FaSave } from "react-icons/fa";
import { decryptFields, encryptFields } from "../../utils/kycStatus";
import { getProfileApi } from "../../redux/features/profileSlice";
import { useDispatch } from "react-redux";
import axiosInstance from "../../utils/axiosInstance";

const fields = [
  { id: "name", label: "Name" },
  { id: "addressLine1", label: "Address 1" },
  { id: "addressLine2", label: "Address 2" },
  { id: "state", label: "State" },
  { id: "city", label: "City" },
  { id: "pincode", label: "Pincode" },
  { id: "mobileNum", label: "Mobile Number" },
];

export default function BillingAddressKyc({
  handleNext,
  GetAddressKycAPI,
  kycDetailApiResponse,
}) {
  const { PanNumber, dob, email, Name, NameOnTheCard, STATUS } =
    kycDetailApiResponse?.[0]?.pan?.msg || {};
  const Token = sessionStorage.getItem("token");

  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [state_code, setstate_code] = useState(0);
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const [selectedStateName, setSelectedStateName] = useState("");
  const [selectedCityName, setSelectedCityName] = useState("");

  const [addressApiData, setAddressApiData] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { values, handleSubmit, handleChange, errors, setValues } = useFormik({
    initialValues: {
      name: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      pincode: "",
      mobileNum: "",
    },
    validationSchema: billingAddressSchema,
    onSubmit: async () => {
      try {
        setLoading(true);
        // const url = `${process.env.REACT_APP_BASE_URL}/address/addaddress`;
        // const headers = {
        //   "Content-Type": "application/json",
        //   Accept: "application/json",
        //   Authorization: `Bearer ${Token}`,
        // };

        // const response = await fetch(url, {
        //   method: "POST",
        //   headers: headers,
        //   body: JSON.stringify(body),
        // });
        // const data = await response.json();

        const payload = {
          city: values.city,
          country: "India",
          line1: values.addressLine1,
          line2: values.addressLine2,
          mobileNumber: values.mobileNum,
          name: values.name,
          state: values.state,
          statecode: String(state_code),
          type: "B",
          zip: values.pincode,
        };

        const res = await axiosInstance.post("/address/addaddress", payload);

        if (!res.data?.error) {
          let userDetails =
            JSON.parse(localStorage.getItem("userDetails")) || {};

          userDetails = decryptFields(userDetails, ["address"]);
          userDetails.address = true;
          userDetails = encryptFields(userDetails, ["address"]);
          localStorage.setItem("userDetails", JSON.stringify(userDetails));

          // Call APIs and proceed to the next panel
          await GetAddressAPI();
          await GetAddressKycAPI();
          dispatch(getProfileApi());
          await handleNext("panel3");

          // Show success message
          toast.success("Address updated successfully");
        } else {
          toast.error(
            `Error: ${res?.data?.message || "Failed to update address"}`
          );
        }
      } catch (error) {
        console.error("ERROR IN CATCH+++++++++++++++++", error);
        toast.error("An error occurred while updating the address");
      } finally {
        setLoading(false);
      }
    },
    validateOnMount: false, // No validation on mount
    validateOnChange: false, // No validation on change
    validateOnBlur: true, // Validate only on blur
  });

  const GetAddressAPI = async () => {
    try {
      // const url = `${process.env.REACT_APP_BASE_URL}/address/get_address`;
      // const headers = {
      //   "Content-Type": "application/json",
      //   Accept: "application/json",
      //   Authorization: `Bearer ${Token}`,
      // };

      // const response = await fetch(url, {
      //   method: "GET",
      //   headers: headers,
      // });

      // const data = await response.json();

      const res = await axiosInstance.get("/address/get_address");
      const { data, error, message } = res.data || {};

      if (!error) {
        const { name, line1, line2, state, city, zip, mobileNumber } =
          data?.[0] || [];
        // console.log("mobilenumber==========>>>",mobileNumber)
        // data?.data[data.data.length - 1] || [];
        setAddressApiData(state);
        let userDetails = JSON.parse(localStorage.getItem("userDetails"));
        setValues({
          name: userDetails?.name || name || "",
          addressLine1: line1 || "",
          addressLine2: line2 || "",
          state: state || "",
          city: city || "",
          pincode: zip || "",
          mobileNum: userDetails?.phone || mobileNumber || "",
        });
      }
    } catch (error) {
      console.error("ERROR IN CATCH+++++++++++++++++", error);
    }
  };

  useEffect(() => {
    GetAddressAPI();
    getStateApi();
  }, []);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
    // if (userDetails.name) {
    setValues((prevValues) => ({
      ...prevValues,
      name: userDetails.name || "",
      mobileNum: userDetails.phone || "",
    }));
    // }
  }, [setValues, kycDetailApiResponse]);

  // ***************************************************************************

  const getStateApi = async () => {
    try {
      // const url = `${process.env.REACT_APP_BASE_URL}/stateCode/getstateCode`;
      // const headers = {
      //   "Content-Type": "application/json",
      //   Accept: "application/json",
      //   Authorization: `Bearer ${Token}`,
      // };
      // const response = await axios.get(url, { headers });
      const response = await axiosInstance.get("/stateCode/getstateCode");
      setStateData(response.data.data);
      setstate_code(response.data);
      return response.data;
    } catch (error) {
      console.log("ERROR IN CATCH======>>>>", error);
    }
  };

  // City Api**************
  const getCityApi = async (stateId) => {
    try {
      // const url = `${process.env.REACT_APP_BASE_URL}/stateCode/getcity`;
      // const url = `${process.env.REACT_APP_BASE_URL}/stateCode/getCitiesOfState`;
      // const headers = {
      //   "Content-Type": "application/json",
      //   Accept: "application/json",
      //   Authorization: `Bearer ${Token}`,
      // };
      // const response = await axios.post(url, body, { headers });
      const response = await axiosInstance.post("/stateCode/getCitiesOfState", {
        _id: stateId,
      });
      setCityData(response.data.data);
    } catch (error) {
      console.error("Error connecting to city API", error);
      throw error;
    }
  };

  // ================================HANDLE CHANGE==============================

  const handleStateChange = async (event, newValue) => {
    if (newValue) {
      setSelectedState(newValue._id); // Set the selected state ID
      setSelectedStateCode(newValue.state_code); // Set the state code
      setSelectedStateName(newValue.name); // Set the state name
      setValues({ ...values, state: newValue.name }); // Update Formik values

      // Call the city API with the selected state ID
      await getCityApi(newValue._id); // Make sure getCityApi accepts a state ID if needed
    } else {
      setSelectedState("");
    }
  };

  const handleCityChange = (event) => {
    const selectedCityId = event.target.value;
    setSelectedCity(selectedCityId);

    // Find the selected city object from cityData
    const selectedCityObject = cityData.find(
      (city) => city._id === selectedCityId
    );

    if (selectedCityObject) {
      setSelectedCityName(selectedCityObject.city_name);

      // Set the city name in Formik's values
      setValues((prevValues) => ({
        ...prevValues,
        city: selectedCityObject.city_name,
      }));
    }
  };

  useEffect(() => {
    if (stateData.length > 0) {
      setSelectedState(stateData[0]._id); // Assuming stateData contains an array of objects with _id field
    }
  }, [stateData]);

  useEffect(() => {
    if (values.state !== "") {
      const filteredCities = cityData.filter(
        (city) => city.state_id === values.state
      );
      if (filteredCities.length > 0) {
        setSelectedCity(filteredCities[0]._id); // Assuming cityData contains an array of objects with _id field
      }
    }
  }, [cityData, selectedState, values.state]);
  return (
    <div>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
      >
        {/* Name Field */}
        <TextField
          id="name"
          label="Name"
          variant="outlined"
          size="small"
          fullWidth
          value={values.name || ""}
          onChange={handleChange}
          error={Boolean(errors.name)}
          helperText={errors.name || ""}
          InputProps={{
            readOnly: true,
          }}
          sx={{ marginBottom: 2 }}
        />

        {/* Address 1 Field */}
        <TextField
          id="addressLine1"
          label="Address 1"
          variant="outlined"
          size="small"
          fullWidth
          value={values.addressLine1 || ""}
          onChange={handleChange}
          error={Boolean(errors.addressLine1)}
          helperText={errors.addressLine1 || ""}
          InputProps={{
            readOnly: addressApiData ? true : false, // Read-only if addressApiData is true
          }}
          sx={{ marginBottom: 2 }}
        />

        {/* Address 2 Field */}
        <TextField
          id="addressLine2"
          label="Address 2"
          variant="outlined"
          size="small"
          fullWidth
          value={values.addressLine2 || ""}
          onChange={handleChange}
          error={Boolean(errors.addressLine2)}
          helperText={errors.addressLine2 || ""}
          InputProps={{
            readOnly: addressApiData ? true : false, // Read-only if addressApiData is true
          }}
          sx={{ marginBottom: 2 }}
        />

        {/* State Autocomplete */}
        {addressApiData ? (
          <TextField
            id="state1"
            label="State"
            variant="outlined"
            size="small"
            fullWidth
            value={values.state || ""}
            sx={{ marginBottom: 2 }}
          />
        ) : (
          <Autocomplete
            disablePortal
            options={stateData || []}
            getOptionLabel={(option) => option.name || ""}
            fullWidth
            size="small"
            value={
              stateData.find((option) => option.name === values.state) || null
            }
            onChange={handleStateChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="State"
                error={Boolean(errors.state)}
                helperText={errors.state || ""}
              />
            )}
            isOptionEqualToValue={(option, value) => option._id === value?._id}
            sx={{ marginBottom: 2 }}
          />
        )}

        {/* City Autocomplete */}
        {addressApiData ? (
          <TextField
            id="city1"
            label="City"
            variant="outlined"
            size="small"
            fullWidth
            value={values.city || ""}
            sx={{ marginBottom: 2 }}
          />
        ) : (
          <Autocomplete
            disablePortal
            freeSolo // ✅ allows typing custom values
            options={cityData || []}
            getOptionLabel={(option) => option || ""}
            fullWidth
            size="small"
            value={values.city || ""} // Directly bind Formik value
            onChange={(event, newValue) => {
              setSelectedCity(newValue);
              setValues({ ...values, city: newValue || "" });
            }}
            onInputChange={(event, newInputValue) => {
              // When user types manually
              setSelectedCity(newInputValue);
              setValues({ ...values, city: newInputValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="City"
                error={Boolean(errors.city)}
                helperText={errors.city || ""}
              />
            )}
            isOptionEqualToValue={(option, value) => option === value}
            sx={{ marginBottom: 2 }}
          />
        )}

        {/* City Autocomplete
        {addressApiData ? (
          <TextField
            id="city1"
            label="City"
            variant="outlined"
            size="small"
            fullWidth
            value={values.city || ""}
            sx={{ marginBottom: 2 }}
          />
        ) : (
          <Autocomplete
            disablePortal
            options={cityData || []}
            getOptionLabel={(option) => option || ""} // Adjust here if the city data is just an array of strings
            fullWidth
            size="small"
            value={cityData.find((option) => option === values.city) || ""}
            onChange={(event, newValue) => {
              setSelectedCity(newValue); // Just set the selected city name directly
              setValues({ ...values, city: newValue }); // Update Formik values
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="City"
                error={Boolean(errors.city)}
                helperText={errors.city || ""}
              />
            )}
            isOptionEqualToValue={(option, value) => option === value} // Adjust for strings
            sx={{ marginBottom: 2 }}
          />
        )} */}

        {/* Pincode Field */}
        <TextField
          id="pincode"
          label="Pincode"
          variant="outlined"
          size="small"
          fullWidth
          value={values.pincode || ""}
          onChange={(e) => {
            // Allow only numbers and restrict to a maximum of 6 digits
            const newValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
            if (newValue.length <= 6) {
              setValues({ ...values, pincode: newValue });
            }
          }}
          inputProps={{ maxLength: 6 }} // Restrict to 6 digits
          error={Boolean(errors.pincode)}
          helperText={errors.pincode || ""}
          InputProps={{
            readOnly: addressApiData ? true : false, // Read-only if addressApiData is true
          }}
          sx={{ marginBottom: 2 }}
        />

        {/* Mobile Number Field */}
        <TextField
          id="mobileNum"
          label="Mobile Number"
          variant="outlined"
          size="small"
          fullWidth
          value={values.mobileNum || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 10 && /^[0-9]*$/.test(value)) {
              handleChange(e); // Proceed only if the value is 10 digits or less and contains only numbers
            }
          }}
          error={Boolean(errors.mobileNum)}
          helperText={errors.mobileNum || ""}
          InputProps={{
            readOnly: addressApiData ? true : false, // Read-only if addressApiData is true
          }}
          inputProps={{ maxLength: 10, readOnly: true }}
          sx={{ marginBottom: 2 }}
        />

        {/* Submit Button */}
        {!addressApiData && (
          <div style={{ display: "flex", justifyContent: "end", gap: "1rem" }}>
            <LoadingButton
              type="submit"
              size="small"
              // onClick={handleClick}
              loading={loading}
              loadingPosition="start"
              startIcon={<FaSave color="white" />}
              variant="contained"
              sx={{
                backgroundColor: "#DA2128",
                color: "white",
                "&:hover": {
                  backgroundColor: "#DA2128",
                },
              }}
            >
              Save
            </LoadingButton>
          </div>
        )}
      </form>
    </div>
  );
}
